import createLoadingBlockQuery from './createLoadingBlockQuery'
import createSingleBlockQuery from './createSingleBlockQuery'
import createHierarchyLoadQuery from './createHierarchyLoadQuery'
import createPageLoadingQuery from './createPageLoadingQuery'
import createSinglePageLoadQuery from './createSinglePageLoadQuery'

export {
  createLoadingBlockQuery,
  createSingleBlockQuery,
  createHierarchyLoadQuery,
  createPageLoadingQuery,
  createSinglePageLoadQuery
}
